import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import NavigationBar from './../../components/navigationBar/NavigationBar';
import DownloadAppBar from './../../components/downloadAppBar/DownloadAppBar';
import TitleBar from './../../components/titleBar/TitleBar';
import { injectIntl, FormattedMessage } from 'react-intl';
import {newDateTime} from './../../utils/Utils';
import DetailsSection from './../../components/detailsSection/DetailsSection';

import styles from './EventDetailsScreen.module.css';

import ClockIcon from './../../assets/img/clock-icon.svg';
import MarkerIcon from './../../assets/img/marker-icon.svg';
import Placeholder from './../../assets/img/placeholder1.jpg';

class EventDetailsScreen extends Component {

    constructor(props){
        super(props);
        this.intl = this.props.intl;
        this.navBarRef = React.createRef();
        this.titleBarRef = React.createRef();
        this.state = {
            readMore: false,
            pageTransitionEnd: false
        }

        window.scrollTo(0, 0);

        this.backTo = this.backTo.bind(this);
        this.animationEnd = this.animationEnd.bind(this);
        this.goToReadMore = this.goToReadMore.bind(this);
        this.shareEvent = this.shareEvent.bind(this);
    }

    componentDidMount(props){
        window.onscroll = function(){
            if(this.navBarRef.current){
                this.navBarRef.current.showHide(window.pageYOffset);
            }
            if(this.titleBarRef.current){
                this.titleBarRef.current.showHide(window.pageYOffset);
            }
        }.bind(this);
    }

    shareEvent() {
        if(navigator.share){
            navigator.share({
                title: this.props.event.event_name,
                url: this.props.event.event_share_url,
                text: this.intl.formatMessage({id: "shareEvent"}) + '\n\n'
            })
        }else{
            alert("This browser cannot use share.");
        }
    }

    goToReadMore() {
        this.setState({
            readMore: !this.state.readMore
        });
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    backTo(){
        this.props.history.goBack();
    }

    formatDuration(duration) {
        var hours   = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - (hours * 3600)) / 60);
        var seconds = duration - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return minutes + ':' + seconds;
    }

    render(){
        let backTo, imageUrl = [], navigationBar, linkText, location, organizer, descriptionContainer, dateHour, animation, eventLink = "", mapAddress = "";

        if (this.props.event){
            if(this.props.event !== "NOT_FOUND"){
                if ((navigator.platform.indexOf("iPhone") != -1) ||
                    (navigator.platform.indexOf("iPad") != -1) ||
                    (navigator.platform.indexOf("iPod") != -1)){
                    mapAddress = "https://maps.google.com/maps?q=" + this.props.event.event_location_name;
                }else{
                    mapAddress = "geo:0,0?q=" + this.props.event.event_location_name;
                }

                let date = newDateTime(this.props.event.start_date);
                date = date.toLocaleDateString(this.intl.locale, {
                    hour12: true,
                    weekday: "short",
                    month: "short",
                    day: "numeric"
                }).replace('de', '');

                date = date.charAt(0).toUpperCase() + date.slice(1);
                dateHour = date + ' - ' + this.props.event.event_time;

                if(this.props.event.event_url !== ""){
                    eventLink = (
                        <p className={styles.moreDetails} onClick={() => window.open(this.props.event.event_url)}>
                            <FormattedMessage id="knowMore" />
                        </p>
                    );
                }

                linkText = "";
                descriptionContainer = styles.descriptionContainerWithoutOpen;

                if(this.props.event.organizer){
                    organizer = (
                        <div className={styles.organizerContainer}>
                            <p><b><FormattedMessage id="organizer" />:</b></p>
                            <p>{this.props.event.organizer}</p>
                        </div>
                    );
                }

                if(this.props.event.event_location !== "" || this.props.event.event_location_name !== ""){
                    location = (
                        <p className={styles.infoContainer}>
                            <ReactSVG src={MarkerIcon} />
                            <div>
                                <span className={styles.textLink} onClick={() => window.open(mapAddress, "_self")}>
                                    <FormattedMessage id="howToArrive" />
                                </span>
                                <br/>
                                <span className={styles.addressText}>
                                    {this.props.event ? this.props.event.event_location_name : ''}
                                </span>
                                <br/>
                                <span className={styles.addressText}>
                                    {this.props.event ? this.props.event.event_location : ''}
                                </span>
                            </div>
                        </p>
                    );
                }

                imageUrl = [Placeholder];
                if(this.props.event.banner_url !== ""){
                    imageUrl = [this.props.event.banner_url];
                }
            }else{
                return (
                    <h2>404 - Page not found</h2>
                );
            }
        }

        if(!this.state.pageTransitionEnd && this.props.location.state && this.props.location.state.animation){
            animation = "animated " + this.props.location.state.animation;
        }

        if(!this.props.shared){
            backTo = this.backTo;
            navigationBar = (
                <div className={styles.navigationBarContainer}>
                    <NavigationBar history={this.props.history} ref={this.navBarRef} active="events"/>
                </div>
            );
        }else{
            navigationBar = (
                <div className={styles.downloadBarContainer}>
                    <DownloadAppBar />
                </div>
            );
        }

        return (
            <TitleBar ref={this.titleBarRef}
                      className={animation}
                      onAnimationEnd={this.animationEnd}
                      backTo={backTo}
                      adjustImage={true}
                      shareButton={this.shareEvent}
                      images={imageUrl}
                      title={this.props.event ? this.props.event.event_name : ''}>
                <DetailsSection>
                    <div className={descriptionContainer}>
                        <p>
                            {this.props.event ? this.props.event.description.trim() : ''}
                        </p>
                    </div>
                    <p></p>
                    <p onClick={this.goToReadMore} className={[styles.textLink, styles.readMore].join(' ')}>
                        <b>{linkText}</b>
                    </p>
                    <p className={styles.infoContainer}>
                        <ReactSVG src={ClockIcon} /> {dateHour}
                    </p>
                    {location}
                    {organizer}
                    {eventLink}
                </DetailsSection>
                {navigationBar}
            </TitleBar>
        );
    }

}

export default injectIntl(EventDetailsScreen);